// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"_19C8rTct","loader":"_1xphiqJk"};